import * as React from "react"
import { matchPath, withRouter, RouteComponentProps } from "react-router-dom"
import MenuGroup, { MenuItem, Props as MenuGroupProps } from "./menu-group"
import MenuHeader from "./menu-header"
import * as routes from "../../util/routes"
import * as Model from "../../model"
import * as LoanDomain from "../../domain/sfp/loan-domain"
import * as UserDomain from "../../domain/sfp/user-domain"
import MenuRefresh from "./menu-refresh"
import manualUser from '../../assets/files/Manuel_utilisateur_V6.pdf'
import { KEY_CURRENT_LOCAL_AUTHORITY } from "../../util/storage"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class Menu extends React.Component<InjectedProps> {
    componentDidMount(): void {
        const result = localStorage.getItem(KEY_CURRENT_LOCAL_AUTHORITY)
        localStorage.removeItem(KEY_CURRENT_LOCAL_AUTHORITY);

        if (result && result !== '') { this.props.onLocalAuthorityChange(parseInt(result)) }
    }

    render() {
        return <nav id="main-menu">
            <MenuRefresh
                currentUser={this.props.currentUser}
                items={[{
                    onClick: () => this.refresh(),
                    title: "Rafraîchir la page"
                }]}
                key={1 - 9}
            />
            <div className="support-links">
                <p className="support-title">Support</p>
                <span><FontAwesomeIcon icon="envelope" /> <a href='mailto:support@sfp-collectivites.fr'>support@sfp-collectivites.fr</a></span><br />
                <span><FontAwesomeIcon icon="phone" /> <a href='tel:0241340421'>02 41 34 04 21</a></span>
            </div>

            <MenuHeader
                currentLocalAuthority={this.props.currentLocalAuthority}
                currentUser={this.props.currentUser}
                loadingCurrentLocalAuthority={this.props.loadingCurrentLocalAuthority}
                loadingCurrentUser={this.props.loadingCurrentUser}
                loadingLocalAuthorities={this.props.loadingLocalAuthorities}
                localAuthorities={this.props.localAuthorities}
                onLocalAuthorityChange={id => this.props.onLocalAuthorityChange(id)} />

            {this.renderMenuGroups()}
        </nav>
    }

    private refresh() {
        setTimeout(() => window.location.reload())
    }

    private downloadUserManual() {
        const link = document.createElement('a')
        link.href = manualUser
        link.download = "SPF_Collectivités_Manuel_Utilisateur_V6.pdf"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    private getAdministrationMenuGroupProps(): MenuGroupProps {
        const items: MenuItem[] = [
            // {
            // 	allowedProfiles: [UserDomain.Profile.SuperAdmin],
            // 	onClick: () => this.props.onMenuItemClick(),
            // 	title: "Cabinets",
            // 	to: routes.OFFICES
            // },
            {
                allowedProfiles: [UserDomain.Profile.SuperAdmin],
                onClick: () => this.props.onMenuItemClick(),
                title: "Collectivités",
                to: routes.LOCAL_AUTHORITIES
            },
            {
                allowedProfiles: [
                    UserDomain.Profile.SuperAdmin,
                    UserDomain.Profile.RegionAdmin,
                    UserDomain.Profile.LocalAuthorityAdmin,
                    UserDomain.Profile.LocalAuthorityConsultant,
                    UserDomain.Profile.Adminbudgetannexe,
                    UserDomain.Profile.Consultantbudgeannexe,
                ],
                onClick: () => this.props.onMenuItemClick(),
                title: "Utilisateurs",
                to: routes.USERS
            },
            {
                allowedProfiles: [UserDomain.Profile.SuperAdmin],
                onClick: () => this.props.onMenuItemClick(),
                title: "Instructions",
                to: routes.INSTRUCTIONS
            },
            {
                onClick: () => this.props.onMenuItemClick(),
                title: "Aide",
                to: routes.AIDE
            },
            {
                allowedProfiles: [UserDomain.Profile.SuperAdmin],
                onClick: () => this.props.onMenuItemClick(),
                title: "Régions",
                to: routes.REGIONS
            },
            {
                allowedProfiles: [UserDomain.Profile.SuperAdmin],
                onClick: () => this.props.onMenuItemClick(),
                title: "Glossaire",
                to: routes.GLOSSAIRE
            },
            {
                allowedProfiles: [UserDomain.Profile.SuperAdmin],
                onClick: () => this.props.onMenuItemClick(),
                title: "Information réglementaire",
                to: routes.INFORMATION_REGLEMENTAIRE
            }
        ]

        return {
            currentUser: this.props.currentUser,
            items,
            title: "Administration"
        }
    }

    private getCustomTrackingMenuGroupProps(
        localAuthoritySlug: string
    ): MenuGroupProps {
        const allowedProfiles: UserDomain.Profile[] = [
            UserDomain.Profile.SuperAdmin,
            UserDomain.Profile.RegionAdmin,
            UserDomain.Profile.LocalAuthorityAdmin,
            UserDomain.Profile.LocalAuthorityConsultant,
            UserDomain.Profile.Adminbudgetannexe,
            UserDomain.Profile.Consultantbudgeannexe,
        ]
        const loansWithDecomposition = LoanDomain
            .getLoansWithDecomposition(this.props.loans)
        const invalidLoansCount = LoanDomain
            .countRequiredValidationLoans(loansWithDecomposition)
        const items: MenuItem[] = [
            {
                allowedProfiles,
                badge: {
                    value: invalidLoansCount,
                    title: "Emprunts nécessitant une validation"
                },
                onClick: () => this.props.onMenuItemClick(),
                title: "Dette",
                to: `/${localAuthoritySlug}${routes.RETROSPECTIVE_DEBT}`
            },
            {
                allowedProfiles,
                onClick: () => this.props.onMenuItemClick(),
                title: "Rapport de gestion",
                to: `/${localAuthoritySlug}${routes.CUSTOM_TRACKING_MANAGEMENT_REPORT}`,
            },
            {
                allowedProfiles,
                onClick: () => this.props.onMenuItemClick(),
                title: "Référentiel de gestion",
                to: `/${localAuthoritySlug}${routes.CUSTOM_TRACKING_POLICY}`,
            },
        ]

        return {
            currentUser: this.props.currentUser,
            items,
            title: "Suivi personnalisé"
        }
    }

    private getLogoutMenuGroupProps(): MenuGroupProps {
        return {
            currentUser: this.props.currentUser,
            items: [
                {
                    onClick: () => this.downloadUserManual(),
                    title: "Manuel utilisateur"
                },
                {
                    onClick: () => this.props.onLogout(),
                    title: "Déconnexion"
                }
            ]
        }
    }

    private renderMenuGroups(): React.ReactNode {

        const match = matchPath<Params>(
            this.props.location.pathname, { path: routes.LOCAL_AUTHORITY_PATTERN })
        const menuGroupsProps: MenuGroupProps[] = []

        if (match || this.props.currentLocalAuthority) {
            const localAuthoritySlug = this.props.currentLocalAuthority
                ? this.props.currentLocalAuthority.slug
                : match.params.slug

            menuGroupsProps.push(this.getRetrospectiveMenuGroupProps(localAuthoritySlug))
            menuGroupsProps.push(this.getProspectiveMenuGroupProps(localAuthoritySlug))
            menuGroupsProps.push(this.getCustomTrackingMenuGroupProps(localAuthoritySlug))
        }

        menuGroupsProps.push(this.getAdministrationMenuGroupProps())
        menuGroupsProps.push(this.getLogoutMenuGroupProps())
        return menuGroupsProps.map((props, index) => {
            return <MenuGroup
                currentUser={props.currentUser}
                items={props.items}
                key={index}
                title={props.title} />
        })
    }

    private getProspectiveMenuGroupProps(
        localAuthoritySlug: string
    ): MenuGroupProps {
        const commonProfiles: UserDomain.Profile[] = [
            UserDomain.Profile.SuperAdmin,
            UserDomain.Profile.RegionAdmin,
            UserDomain.Profile.LocalAuthorityAdmin,
            UserDomain.Profile.LocalAuthorityConsultant,
            UserDomain.Profile.Adminbudgetannexe,
            UserDomain.Profile.Consultantbudgeannexe,
        ]
        const items: MenuItem[] = [
            {
                allowedProfiles: [...commonProfiles, UserDomain.Profile.ServiceAgent],
                onClick: () => this.props.onMenuItemClick(),
                title: "Scénarii de fonctionnement",
                to: `/${localAuthoritySlug}${routes.PROJECTION_SCENARII}`
            },
            {
                allowedProfiles: commonProfiles,
                onClick: () => this.props.onMenuItemClick(),
                title: "Plan pluriannuel d'investissement",
                to: `/${localAuthoritySlug}${routes.PPI}`
            },
            {
                allowedProfiles: [...commonProfiles, UserDomain.Profile.ServiceAgent],
                onClick: () => this.props.onMenuItemClick(),
                title: "Compteurs",
                to: `/${localAuthoritySlug}${routes.PROJECTION_COUNTERS}`
            }
        ]
        return {
            currentUser: this.props.currentUser,
            items,
            title: "Projection financière"
        }
    }

    private getRetrospectiveMenuGroupProps(
        localAuthoritySlug: string
    ): MenuGroupProps {
        const allowedProfiles: UserDomain.Profile[] = [
            UserDomain.Profile.SuperAdmin,
            UserDomain.Profile.RegionAdmin,
            UserDomain.Profile.LocalAuthorityAdmin,
            UserDomain.Profile.LocalAuthorityConsultant,
            UserDomain.Profile.Adminbudgetannexe,
            UserDomain.Profile.Consultantbudgeannexe,
        ]
        const items: MenuItem[] = [
            {
                allowedProfiles,
                onClick: () => this.props.onMenuItemClick(),
                title: "Fonctionnement",
                to: `/${localAuthoritySlug}${routes.RETROSPECTIVE_OPERATION}`
            },
            {
                allowedProfiles,
                onClick: () => this.props.onMenuItemClick(),
                title: "Investissement",
                to: `/${localAuthoritySlug}${routes.RETROSPECTIVE_INVESTMENT}`
            },
            {
                allowedProfiles,
                onClick: () => this.props.onMenuItemClick(),
                title: "Récapitulatif",
                to: `/${localAuthoritySlug}${routes.RETROSPECTIVE_SUMMARY}`
            },
            {
                allowedProfiles,
                onClick: () => this.props.onMenuItemClick(),
                title: "Ratios",
                to: `/${localAuthoritySlug}${routes.RETROSPECTIVE_RATIOS}`
            }
        ]

        return {
            currentUser: this.props.currentUser,
            items,
            title: "Constat rétrospectif"
        }
    }
}

export default withRouter(Menu)

export interface Props {
    currentLocalAuthority: Model.LocalAuthority;
    currentUser: Model.User;
    loadingCurrentLocalAuthority: boolean;
    loadingCurrentUser: boolean;
    loadingLocalAuthorities: boolean;
    loans: Model.Loan[];
    localAuthorities: Model.LocalAuthority[];
    open: boolean;
    onLocalAuthorityChange(id: number): void;
    onLogout(): void;
    onMenuItemClick(): void;
}

interface Params {
    slug: string
}

type InjectedProps = Props & RouteComponentProps<Params>


// WEBPACK FOOTER //
// ./src/component/menu/index.tsx